// @js-import "@shared/screen-size.js"

const RWD_SCREEN_SIZE_READY = 'rwd-screen-size-ready';

function extendz(claz, superclaz) {
    function Inner() {}
    Inner.prototype = superclaz.prototype;
    claz.prototype = new Inner();
    claz.prototype.constructor = claz;
}

function runAndReplaceContentHandler(callback) {
    document.body.addEventListener('contentarea-created', (e) => callback(e.target));
    document.body.addEventListener('element-html-replaced', (e) => callback(e.target));
    document.body.addEventListener('content-replace', (e) => {
        // "komponenty" w celu pominięcia React
        Array.from(e.target.querySelectorAll('.react-component, .component')).forEach((component) => callback(component));
    });

    const bindResizeListener = () => {
        const ScreenSize = rwd.ScreenSize;
        if (!ScreenSize) {
            return;
        }
        $(document).onPage(ScreenSize.RESIZE_EVENT_NAME , () => {
            Array.from(document.querySelectorAll('.react-component, .component')).forEach((component) => callback(component));
        });
    };

    if (window.rwd && rwd.ScreenSize) {
        bindResizeListener();
    } else {
        document.addEventListener(RWD_SCREEN_SIZE_READY, function onRwdScreenSizeReady() {
            document.removeEventListener(RWD_SCREEN_SIZE_READY, onRwdScreenSizeReady);
            bindResizeListener();
        });
    }
}


function linkedContent(root, containerSelector, linkSearch, condition) {
    root.on("click keydown", containerSelector, function(e) {
        if (condition && !condition()) {
            return;
        }

        // Obsługa {event} keydown 'Enter'
        if (e.keyCode !== 13 && e.type !== 'click') return;

        var a;
        var $target = $(e.target);
        if ($target.closest("A")[0]) {
            // kliknięcie w A więc nic nie robimy
            return;
        }

        var $container = $target.closest(containerSelector);
        if (typeof linkSearch == "string") {
            // przekazany string czyli selector szukania wewnątrz contenera
            a = $container.find(linkSearch);
        } else if (typeof linkSearch == "function") {
            // przekazana funkcja która jako argument otrzyma $target, nie container gdyż powstaja na zewnątrz, tam
            // gdzie containerSelector jest znany i przekazywany jako argument
            a = linkSearch.call(this, $target);
        } else {
            // szukanie w buttonach i luzem
            a = $container.find(".buttons A");
            if (!a[0]) {
                a = $container.find("A");
            }
        }
        if (!a[0]) {
            // nie ma linku
            return;
        }

        $container.addClass('highlightingCliksLink');
        setTimeout(function() {
            $container.removeClass('highlightingCliksLink');
            simulateClick(a[0]);
        }, 100);
    });

    function simulateClick(el) {
        try {
        var evt = document.createEvent("MouseEvents");
        evt.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0,
        false, false, false, false, 0, null);
        el.dispatchEvent(evt);
        } catch(err) {
            el.click();
        }
    }
}

function ckEditorPluginExpand($componentElement) {
    const expandableElement = $componentElement.find('.expand-button');

    expandableElement.each(function () {
        var buttonContainer = $(this),
            button = buttonContainer.find('a'),
            contentArea = button.closest('.content_area'),
            collapseLabel = button.attr('data-collapse'),
            expandLabel = button.attr('data-expand'),
            $collapsibleContent;

        buttonContainer.nextAll().wrap('<div class="collapsible-content" />');
        $collapsibleContent = contentArea.find('.collapsible-content');
        buttonContainer.detach().appendTo(contentArea);

        if(button.hasClass("plugin-only-modal")) {
            button.closest(".content_area").addClass("plugin-only-modal");
        }

        button.onPage("click", function(event) {
            event.preventDefault();
            var _self = $(this);
            _self.toggleClass('link--active');
            if($collapsibleContent.hasClass("visible")){
                $collapsibleContent
                    .slideUp()
                    .removeClass('visible');
                button.text(expandLabel);
            } else {
                $collapsibleContent
                    .slideDown()
                    .addClass('visible');
                button.text(collapseLabel);
            }
        });
    });
}

function ckEditorPluginLikToFile() {
    $("#outlet-content").on('content-replace', function() {
        $('.link_to_file').each(function () {
            var containerFile = $(this).find('a'),
                labelFile = containerFile.find('.file_download');
            containerFile.addClass("link_to_file__href")
            if(!labelFile.exists()) {
                containerFile.addClass("no-label-file");
            }
        });
    });
}

function ckEditorPluginChangelog() {
    const plugin_changelog = $('.plugin_changelog'),
          plugin_changelog_parent = plugin_changelog.parent();

        plugin_changelog_parent.find(".plugin_changelog:first-child").addClass("first-element");
        plugin_changelog_parent.find(".plugin_changelog:last-of-type").addClass("last-element");
}

const addRoleToLists = (context = document.body) => {
    /* Obsługa WCAG - na potrzeby czytników na Safari */
    context.querySelectorAll('ul, ol').forEach((list) => {
        list.setAttribute('role', 'list');
    });
};

const wrapTablesForScroll = (context = document.body) => {
    context.querySelectorAll('.ck-editor-table').forEach((table) => {
        if (table.parentElement?.classList.contains('table-scroll')) return;

        const wrapper = document.createElement('div');
        wrapper.classList.add('table-scroll');

        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
};

const addSrOnlySpan = (link) => {
    if (!link.querySelector('.sr-only')) {
        const srOnlySpan = document.createElement('span');
        srOnlySpan.classList.add('sr-only');
        srOnlySpan.textContent = 'otworzy się w nowej karcie';
        link.appendChild(srOnlySpan);
    }
};

const enhanceExternalLinks = (context = document.body) => {
    const linksWithTargetBlank = context.querySelectorAll('a[target="_blank"]');

    linksWithTargetBlank.forEach(link => {
        // Sprawdzamy, czy link posiada jakąkolwiek klasę
        if (link.classList.length > 0) {
            addSrOnlySpan(link);
            return;
        }

        if (!link.classList.contains('link--external')) {
            link.classList.add('link--external');
        }

        addSrOnlySpan(link);

        if (!link.querySelector('.web-icon.link-ext')) {
            const iconSpan = document.createElement('span');
            iconSpan.classList.add('web-icon', 'link-ext');
            iconSpan.setAttribute('aria-hidden', 'true');
            link.appendChild(iconSpan);
        }
    });
};


const setBackgroundVariableForLinks = (context = document.body) => {
    const links = context.querySelectorAll('a');

    links.forEach(link => {
        if (!link.querySelector('.web-icon')) return;

        let currentElement = link;

        while (currentElement) {
            const computedBgColor = window.getComputedStyle(currentElement).backgroundColor;

            if (computedBgColor !== 'rgba(0, 0, 0, 0)' && computedBgColor !== 'transparent') {
                link.style.setProperty('--parent-background-color', computedBgColor);
                break;
            }

            currentElement = currentElement.parentElement;
        }
    });
};

const handleIframeModalUrl = () => {
    document.addEventListener('dialog-opened', (e) => {
        const { modalId } = e.detail;
        const dialog = document.getElementById(modalId);

        if (!dialog) return;

        const iframe = dialog.querySelector('iframe[data-modal-url]');
        if (iframe) {
            const modalUrl = iframe.getAttribute('data-modal-url');
            if (modalUrl) {
                iframe.setAttribute('src', modalUrl);
            }
        }
    });

    document.addEventListener('dialog-closed', (e) => {
        const { modalId } = e.detail;
        const dialog = document.getElementById(modalId);

        if (!dialog) return;

        const iframe = dialog.querySelector('iframe[data-modal-url]');
        if (iframe) {
            iframe.setAttribute('src', '');
        }
    });
};

const checkTimeControlledVisibility = (context = document.body) => {
    const elements = context.querySelectorAll('.time-controlled-visibility');

    if (!elements.length || ComponentsManager.isBuilder()) return;

    const now = new Date();
    const currentDay = now.getDay() === 0 ? 7 : now.getDay(); // Niedziela jako 7
    const currentTime = now.getHours() * 60 + now.getMinutes(); // Czas w minutach od północy

    const toMinutes = (time) => {
        const [h, m] = time.split(':').map(Number);
        return h * 60 + m;
    };

    const isDayMatch = (dayItems) => {
        return dayItems.some(dayItem => {
            if (dayItem.includes('-')) {
                const [startDay, endDay] = dayItem.split('-').map(Number);
                return currentDay >= startDay && currentDay <= endDay;
            }
            return currentDay === Number(dayItem);
        });
    };

    const isTimeMatch = (start, end) => {
        const startM = toMinutes(start);
        const endM = toMinutes(end);
        return currentTime >= startM && currentTime <= endM;
    };

    elements.forEach(el => {
        const timeData = el.getAttribute('data-time-visibility');

        if (!timeData) return;

        const entries = timeData.split(';').map(item => item.trim());

        const isVisible = entries.some(entry => {
            const parts = entry.split(',');
            if (parts.length < 2) return false;

            const hours = parts.pop();
            const days = parts.join(',');
            const dayItems = days.split(',');

            if (!isDayMatch(dayItems)) return false;

            const [start, end] = hours.split('-');
            if (!start || !end) return false;

            return isTimeMatch(start, end);
        });

        if (isVisible) {
            el.classList.add('is-visible');
        }
    });
};

const toggleZoomClass = () => {
    const updateZoomClass = () => {
        document.body.classList.toggle(
            'state-zoom300',
            window.devicePixelRatio >= 3 && window.innerHeight/window.innerWidth < 1
        );
        document.body.classList.toggle(
            'state-zoom400',
            window.devicePixelRatio >= 4 && window.innerHeight/window.innerWidth < 1
        );
    };

    updateZoomClass();
    window.addEventListener('resize', updateZoomClass);
};

const getAnnounceTitle = () => {
    const h1 = document.querySelector('h1');

    if (h1 && h1.textContent) {
        return h1.textContent;
    }
    if (document.title) {
        return document.title;
    }
    return null;
};

const announcePageChange = () => {
    const live = document.getElementById('aria-live-region');
    if (!live) return;

    const title = getAnnounceTitle();
    if (!title) return;

    live.textContent = `Wyświetlono stronę ${title}`;
};

const focusSkipLinks = () => {
    const outlet = document.getElementById('outlet-header');
    const uc = getUserComponent(outlet, 'skip-links-nav');
    if (!uc) {
        return;
    }
    ucLoadHelper(uc, () => {
        const nav = uc.querySelector('#skipLinksNav');
        if (!nav) {
            return;
        }
        nav.setAttribute('tabindex', '-1');
        nav.focus();
    });
};

const initSkipLinks = (context) => {
    // Sprawdzam, czy to header przyszedł w context
    if (!context.classList.contains('header')) return;
    // Ponieważ skip linki są wyżej od componetn szukam rodzica
    const outletHeader = context.closest('#outlet-header');
    if (!outletHeader) return;

    const node = outletHeader.querySelector('cms-user-component');
    if (!node) return;

    // Upewniam się, że outlet-content jest focusowalny
    $('#outlet-content').attr('tabindex', '-1');

    const handleSkipButtons = (ucNode) => {
        const skipButtons = ucNode.querySelectorAll('.skipLinks__button');
        if (!skipButtons.length) return;

        skipButtons.forEach((btn) => {
            // najpierw odpinam ewentualne stare eventy, żeby nie dublować
            btn.removeEventListener('click', btn._skipClickHandler);

            const clickHandler = function(e) {
                e.preventDefault();
                const href = e.target.getAttribute('href');
                const $el = $(href).focus();

                if ($el.is('a, button')) {
                    $el.addClass('isKeyboardFocused');
                }
            };

            btn.addEventListener('click', clickHandler);
            // zapisuje referencję do handlera, żeby można było usunąć przy rerenderze
            btn._skipClickHandler = clickHandler;
        });
    };

    ucLoadHelper(node, handleSkipButtons);
};

const getUserComponent = (node, name) => node.querySelector(`cms-user-component[src*="user-component/${name}"]`);

const ucLoadHelper = (node, callback) => {
    // jeśli UC jest już załadowany
    if (node.getAttribute('loaded') === 'yes') {
        callback(node);
    } else {
        // w przeciwnym razie czekamy na event render
        node.addEventListener('cms-user-component-render', () => {
            callback(node);
        });
    }
}

runAndReplaceContentHandler(function(context) {
    addRoleToLists(context);
    checkTimeControlledVisibility(context);
    enhanceExternalLinks(context);
    initSkipLinks(context);
    setBackgroundVariableForLinks(context);
    wrapTablesForScroll(context);
});
handleIframeModalUrl();
toggleZoomClass();


document.getElementById('outlet-content').addEventListener('content-replace', (e) => {
    announcePageChange();
    // Po zmianie treści po zmianie adresu
    if (e.detail.locationChangeType === 'load') {
        return;
    }
    focusSkipLinks();
});

runFunction(function () {
    const bodyNode = document.querySelector('body');
    if (ComponentsManager.isPreview()) {
        bodyNode.classList.add('isPreview');
    }
    if (ComponentsManager.isBuilder()) {
        bodyNode.classList.add('isBuilder');
    }


    /*JS do obsługi pluginu ckEditor :: Dodanie box z linkiem do zasobu*/
    ckEditorPluginLikToFile()
    ckEditorPluginChangelog();

    $(document).onPage('mousedown', '[data-ripple]', function(evt) {
        var $self = $(this),
            initPos = $self.css("position"),
            offs = $self.offset(),
            diameter = Math.min(this.offsetHeight, this.offsetWidth, 100),
            axis = {
                x: evt.pageX - offs.left,
                y: evt.pageY - offs.top
            },
            $ripple = $('<div/>', {
                class: "ripple-effect",
                appendTo: $self
            });
    
        if (!initPos || initPos === "static") {
            $self.css({position: "relative"});
        }
    
        $('<div/>', {
            class: "ripple-effect__wave",
            css: {
                width: diameter,
                height: diameter,
                left: axis.x - (diameter / 2),
                top: axis.y - (diameter / 2)
            },
            appendTo: $ripple,
            one: {
                animationend: function() {
                    $ripple.remove();
                }
            }
        });
    });
});
